import Vue from 'vue';
import Router from 'vue-router';

import withUser from '~lib/common/hoc/withUser';
import auth from '~lib/common/providers/auth';

import Cases from '../screens/Cases.vue';
import CaseEditor from '../screens/Editor.vue';
import CaseBuilder from '../screens/Builder.vue';
import Grades from '../screens/Grades.vue';
import Assignments from '../screens/Assignments.vue';
import Login from '../screens/auth/Login.vue';
import LoginCallback from '../screens/auth/LoginCallback';
import OdinHandoff from '../screens/auth/OdinHandoff';
import OrgSelection from '../screens/auth/OrgSelection';
import AssignmentList from '../components/assignments/AssignmentList';
import AssignmentEditor from '../components/assignments/AssignmentEditor';

Vue.use(Router);

const routes = [
  {
    path: '/cases',
    name: 'cases',
    component: withUser()(Cases),
  },
  {
    path: '/cases/new',
    name: 'case-builder',
    component: CaseBuilder,
  },
  {
    path: '/cases/edit/:id?',
    name: 'case-editor',
    component: CaseEditor,
  },
  {
    path: '/cases/grades/:id?',
    name: 'grades',
    meta: {
      authorizedRoles: ['SUPER_ADMIN', 'ADMIN', 'USER']
    },
    component: Grades,
  },
  {
    path: '/auth/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/auth/callback',
    name: 'callback',
    component: LoginCallback
  },
  {
    path: '/auth/odin-handoff',
    name: 'odin-handoff',
    component: OdinHandoff
  },
  {
    path: '/auth/org-selection',
    name: 'org-selection',
    component: OrgSelection
  },
  {
    path: '/assignments',
    component: Assignments,
    meta: {
      authorizedRoles: ['SUPER_ADMIN', 'ADMIN', 'USER']
    },
    children: [
      {
        path: '/',
        name: 'assignment-list',
        component: AssignmentList,
      },
      {
        path: 'edit/:assignmentId?',
        name: 'assignment-editor',
        component: AssignmentEditor,
      },
    ],
  },
  {
    // We have nothing at the /authoring base, so redirect to /authoring/cases
    path: '/',
    redirect: '/cases'
  },
];

const router = new Router({
  mode: 'history',
  base: '/authoring',
  routes
});


router.beforeEach((to, from, next) => {
  const user = auth.getUser();
  const { role } = user || {};
  const isAuthorized = to.matched.every((route) => {
    if (
      route.meta &&
      route.meta.authorizedRoles &&
      !route.meta.authorizedRoles.includes(role)
    ) {
      return false;
    }
    return true;
  });
  if (!isAuthorized) {
    return next({name: 'cases'});
  }
  next();
});

export default router;
